import cn from "classnames";

import styles from "./FileCard.module.scss";

import type { FunctionComponent } from "react";
import type { FileCard_file$data } from "__generated__/FileCard_file.graphql";
import type { Size } from "./FileCard";

export const FallbackFileCard: FunctionComponent<{
  file?: FileCard_file$data;
  size?: Size;
  readonly?: boolean;
  selecting?: boolean;
  selected?: boolean;
  cantDeselect?: boolean;
  handleCheckboxChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
}> = ({
  file,
  size,
  readonly = true,
  selecting = false,
  selected = false,
  cantDeselect = false,
  handleCheckboxChange,
  onClick,
}) => {
  let pendingStatusText = "";
  if (file && !file.isUploaded) {
    pendingStatusText = "Not uploaded";
  } else if (file && !file.thumbnailUrl) {
    pendingStatusText = "No thumbnail";
  }

  return (
    <div
      className={cn(
        "bg-gray-100 dark:bg-gray",
        "shadow-[0_0_8px_2px] shadow-gray-300 dark:shadow-gray",
        "hover:shadow-cardHover dark:hover:shadow-cardHover",
        "flex flex-col items-center justify-center",
        "relative"
      )}
      style={{
        ...size,
        cursor: onClick ? "pointer" : "auto",
      }}
      onClick={onClick}
    >
      {pendingStatusText && (
        <div
          className={cn(
            "absolute right-2 top-2",
            "bg-gray dark:bg-gray-100",
            "text-white dark:text-black",
            "rounded",
            "text-center text-xs",
            "px-1.5"
          )}
        >
          {pendingStatusText}
        </div>
      )}
      {file && <p className="my-0 text-clip break-all p-3 text-black/50">{file.filename}</p>}
      {!readonly && (
        <input
          className={cn(selecting ? styles.selectedCheckbox : styles.hoverableCheckbox)}
          type="checkbox"
          checked={selected}
          onChange={handleCheckboxChange}
          disabled={selected && cantDeselect}
        />
      )}
    </div>
  );
};
